import { HAS_WINDOW } from '@eventbrite/feature-detection';
import { logEvent } from '@eventbrite/statsig';

const TRACK_ANY_FILTER_CLICK_STATSIG = 'Search - Filters - Click - Any';
const getTrackFilterTypeString = (filterType: string): string =>
    `Search - Filters - Click - ${filterType}`;
const getWindowWidth = () => (HAS_WINDOW ? `${window.innerWidth}` : '');
export const trackFiltersForStatsig = (key: string) => {
    const windowWidth = getWindowWidth();
    logEvent(TRACK_ANY_FILTER_CLICK_STATSIG, 1, {
        deviceWidth: windowWidth,
    });
    logEvent(getTrackFilterTypeString(key), 1, {
        deviceWidth: windowWidth,
    });
};
